import { differenceInCalendarDays } from "date-fns";
import { useTranslate } from "ra-core";
import { cn } from "@/lib/utils";

// Time left until (or since) a due date: "today", "in 3 days", "2 days overdue".
// Overdue is styled destructive. Day-granularity is enough for task due dates.
export function DueCountdown({
  date,
  className,
}: {
  date?: string | null;
  className?: string;
}) {
  const translate = useTranslate();
  if (!date) return null;

  const days = differenceInCalendarDays(new Date(date), new Date());
  const overdue = days < 0;

  let label: string;
  if (days === 0) {
    label = translate("resources.tasks.due.today");
  } else if (days === 1) {
    label = translate("resources.tasks.due.tomorrow");
  } else if (days > 1) {
    label = translate("resources.tasks.due.in_days", { smart_count: days });
  } else {
    label = translate("resources.tasks.due.overdue", { smart_count: -days });
  }

  return (
    <span className={cn(overdue && "text-destructive font-medium", className)}>
      {label}
    </span>
  );
}
